import React from "react";
import { motion } from "framer-motion";
import {
  Brain,
  Layout,
  Zap,
  FileCheck,
  Eye,
  TrendingUp,
} from "lucide-react";

const items = [
  {
    title: "AI-Optimized for Recruiters",
    desc: "Trained on what hiring managers actually scan for in the first 6 seconds. Every resume is human-reviewed before delivery.",
    Icon: Brain,
  },
  {
    title: "Modern Professional Design",
    desc: "Clean typography, intentional whitespace, and a layout that just feels expensive.",
    Icon: Layout,
  },
  {
    title: "Delivered Fast",
    desc: "Delivered in minutes — AI analyzes, rewrites, and polishes your CV instantly.",
    Icon: Zap,
  },
  {
    title: "ATS-Friendly",
    desc: "Built to pass Applicant Tracking Systems used by 99% of Fortune 500 companies.",
    Icon: FileCheck,
  },
  {
    title: "Easy to Read",
    desc: "Structured for human eyes. Skimmable, scannable, instantly understandable.",
    Icon: Eye,
  },
  {
    title: "Increases Interview Chances",
    desc: "Keyword-rich content engineered to surface in recruiter searches.",
    Icon: TrendingUp,
  },
];

export const Benefits = () => {
  return (
    <section
      id="benefits"
      className="relative py-24 sm:py-32"
      data-testid="benefits-section"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.18em] text-zinc-500">
            Why CV AI PRO
          </p>
          <h2
            className="mt-3 text-3xl md:text-4xl font-semibold tracking-tight text-white text-balance"
            data-testid="benefits-headline"
          >
            Built to get you noticed. Engineered to get you hired.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(({ title, desc, Icon }, idx) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: idx * 0.05 }}
              className="group relative rounded-2xl border border-white/10 bg-zinc-950/50 p-6 hover:border-white/20 hover:bg-zinc-950/80 transition-all duration-300"
              data-testid={`benefit-card-${idx}`}
            >
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-gradient-to-br from-zinc-900 to-black">
                <Icon className="h-5 w-5 text-white/90" />
              </div>
              <h3 className="mt-5 text-base font-medium text-white">
                {title}
              </h3>
              <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                {desc}
              </p>
              <div
                aria-hidden
                className="pointer-events-none absolute -inset-px rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity"
                style={{
                  background:
                    "radial-gradient(400px circle at 50% 0%, rgba(99,102,241,0.10), transparent 40%)",
                }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
